module.exports = __webpack_public_path__ + "img/online-forum.251ec0cb.svg";